import { command } from "@lookiero/messaging";
import { NotificationType } from "../model/notification";
const CREATE_MODAL_NOTIFICATION = "create_modal_notification";
const createModalNotification = ({ aggregateId, ...payload }) => ({
    ...command({ aggregateId, name: CREATE_MODAL_NOTIFICATION }),
    ...payload,
    type: NotificationType.MODAL,
});
export { CREATE_MODAL_NOTIFICATION, createModalNotification };
